export enum EnumCompanyQueries {
  ROUTE_QUERY_RESUME_ID = 'resume-id',
}
